import { DefaultService } from '@/services/DefaultService';

export default class AssProdutoEmpresaService extends DefaultService {

	constructor(http, router, env) {
		super(http, router, env);
	}

  findByIdProduto(column, order, page = 0, limit = 50, situacao, idproduto, ...params) {
    return this._http.get(encodeURI(`${this._env}/ven/produto/assprodutofornecedor/getByProdutos.json?situacao=${situacao}&page=${page}&limit=${limit}&order=${order}&column=${column}&idproduto=${idproduto}&param=${params}`), this._headers).then(res => {
      return res.body;
    }, err => {
      this.verifyError(err);
      throw new Error('Problems while jobs are loading');
    });
	}

  findFornecedorNaoAssociadosProduto(column, order, page = 0, limit = 50, idproduto, ...params) {
    return this._http.get( encodeURI(`${this._env}/ven/produto/assprodutofornecedor/getnaoassociados.json?page=${page}&limit=${limit}&order=${order}&column=${column}&idproduto=${idproduto}&param=${params}`), this._headers ).then(res => {
        return res.body;
    }, err => {
        this.verifyError(err);
        throw err;
    });
    }

    save(form) {
    return this._http.post(`${this._env}/ven/produto/assprodutofornecedor`, form, this._headers).then(res => {
        return res.body;
    }, err => {
        this.verifyError(err);
        throw err;
    });
    }

    updateSituacao(produtofornecedor) {
        return this._http.post(`${this._env}/ven/produto/assprodutofornecedor/updatesituacao`, produtofornecedor, this._headers).then(res => {
          return res.body;
        }, err => {
          this.verifyError(err);
          throw err;
        });
      }
}